import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ t("path", {
  fill: "#1F2937",
  d: "M8 8.667a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334"
}, null, -1), a = /* @__PURE__ */ t("path", {
  fill: "#000",
  d: "M10.667 8.667a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334M5.333 8.667a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#000",
  d: "M12.713 3.287A6.667 6.667 0 0 0 1.86 10.62a.7.7 0 0 1 .06.427l-.587 2.82a.67.67 0 0 0 .404.753q.127.05.263.047h.133l2.854-.574a.84.84 0 0 1 .426.06A6.667 6.667 0 0 0 12.747 3.3zm.554 5.573a5.333 5.333 0 0 1-7.334 4.053 2.2 2.2 0 0 0-.833-.173q-.188 0-.373.033l-1.88.38.38-1.88a2.06 2.06 0 0 0-.14-1.206 5.333 5.333 0 1 1 10.18-1.207"
}, null, -1), s = [
  n,
  a,
  c
];
function d(h, i) {
  return e(), l("svg", o, [...s]);
}
const _ = { render: d };
export {
  _ as default,
  d as render
};
